import { FormControl, FormHelperText, InputProps, OutlinedInput } from "@mui/material";
import styles from "./HolzfinderInputLabled.module.css";

// export interface HolzfinderInputProps extends BaseTextFieldProps {
//   onChange: any;
// }
interface BaseTextFieldPropsWithInputProps extends InputProps {
  InputProps?: any;
  onChange?: any;
  pattern?: any;
  label?: string;
  helperText?: string;
}
interface BaseTextFieldPropsWithInputProps extends InputProps {
  InputProps?: any;
}


export default function HolzfinderInputLabled(props: BaseTextFieldPropsWithInputProps) {
  const { id, label, helperText, error } = props;
  const propsWithoutLabel = { ...props };
  delete propsWithoutLabel.label;
  delete propsWithoutLabel.sx;
  delete propsWithoutLabel.helperText;
  return (
    <FormControl
      sx={{
        marginRight: { xs: 1, md: 6 },
        width: "100%",
      }}
      className={styles.form}
      error={Boolean(error)}
    >
      <label htmlFor={id} style={{ marginBottom: "8px" }}>{label}</label>
      <OutlinedInput
        id={id}
        sx={{
          height: 51,
          borderRadius: "30px",
          width: "100%",
        }}
        className={styles.input}
        {...propsWithoutLabel}
      />
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
}